import Service from '../Service'
import {http} from '../config'

export default class EmpresaService extends Service{

    constructor(){
        super('empresa');
    }

    GetLogo(id){
        return http.get(`${this._nomeControle}/${id}/logo`);
    }

    GetAssinatura(id){
        return http.get(`${this._nomeControle}/${id}/assintura`);
    }

    EnviarLogo(id, arquivo){
        let bodyFormData = new FormData();

        var blob = new Blob([arquivo], { type: 'image/png' });

        bodyFormData.append('arquivo', blob);

        return http.post(`${this.getNomeControle()}/${id}/logo`, bodyFormData, {
            headers: {'Content-Type': 'multipart/form-data' }
        });
    }

    EnviarAssinatura(id, arquivo){
        let bodyFormData = new FormData();

        var blob = new Blob([arquivo], { type: 'image/png' });

        bodyFormData.append('arquivo', blob);

        return http.post(`${this.getNomeControle()}/${id}/assintura`, bodyFormData, {
            headers: {'Content-Type': 'multipart/form-data' }
        });
    }

    ExcluirLogo(id){
        return http.delete(`${this._nomeControle}/${id}/logo`);
    }

    ExcluirAssinatura(id){
        return http.delete(`${this._nomeControle}/${id}/assintura`);
    }

    Cadastrar(modelo, senha, origem){
        return http.post(`${this._nomeControle}`, modelo, {
            params:{
                senha,
                origem
            }
        })
    }

    //ADMINISTRATIVO
    ListarAdministrativo(skip, take, cpfCnpj, nome, plano, situacao, crm){
        return http.get(`${this._nomeControle}/Administrativo/Listar`, {
            params:{
                skip,
                take,
                cpfCnpj,
                nome,
                plano,
                situacao,
                crm
            }
        });
    }

}